import React from 'react';
import Icon from '../../../components/AppIcon';

const TaskQueuePanel = ({ tasks, onTaskClick }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'urgent':
        return 'bg-error/10 text-error border-error/20';
      case 'high':
        return 'bg-warning/10 text-warning border-warning/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending':
        return 'Clock';
      case 'in-progress':
        return 'PlayCircle';
      case 'completed':
        return 'CheckCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="h-full flex flex-col bg-card">
      <div className="p-4 border-b border-border">
        <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="ListTodo" size={20} />
          Meine Aufgaben
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          {tasks?.filter(t => t?.status !== 'completed')?.length} offene Aufgaben
        </p>
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-thin p-4 space-y-3">
        {tasks?.map((task) => (
          <div
            key={task?.id}
            onClick={() => onTaskClick(task)}
            className={`p-3 rounded-lg border-2 cursor-pointer transition-all hover:shadow-md ${getPriorityColor(task?.priority)}`}
          >
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="flex items-center gap-2 flex-1">
                <Icon name={getStatusIcon(task?.status)} size={16} />
                <span className="font-medium text-sm">{task?.title}</span>
              </div>
              {task?.priority === 'urgent' && (
                <Icon name="AlertCircle" size={16} className="text-error flex-shrink-0" />
              )}
            </div>

            <div className="space-y-1.5">
              <div className="flex items-center gap-2 text-xs">
                <Icon name="User" size={14} />
                <span>{task?.clientName}</span>
                <span className="text-muted-foreground">({task?.clientId})</span>
              </div>

              <div className="flex items-center gap-2 text-xs">
                <Icon name="Calendar" size={14} />
                <span>{task?.dueDate}</span>
                <span className="text-muted-foreground">{task?.dueTime}</span>
              </div>

              {task?.notes && (
                <p className="text-xs text-muted-foreground mt-2 line-clamp-2">
                  {task?.notes}
                </p>
              )}
            </div>

            {task?.tags && task?.tags?.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-2">
                {task?.tags?.map((tag, idx) => (
                  <span
                    key={idx}
                    className="px-2 py-0.5 text-xs rounded-full bg-primary/10 text-primary"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="p-4 border-t border-border">
        <button className="w-full py-2 px-4 bg-primary text-primary-foreground rounded-md hover:opacity-90 transition-opacity flex items-center justify-center gap-2 text-sm font-medium">
          <Icon name="Plus" size={16} />
          Neue Aufgabe erstellen
        </button>
      </div>
    </div>
  );
};

export default TaskQueuePanel;